import React from "react";
import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { businessPath } from "../../config/businessMenu";

/**
 * Shown when a project has no linked WhatsApp phone_number_id yet.
 */
const WhatsAppConnectPrompt = ({
  projectId,
  title = "Connect WhatsApp to get started",
  description = "This project is not linked to a WhatsApp Business number yet. Connect your number in project settings to see live chats, contacts, and campaigns for your business — not shared demo data.",
  compact = false,
}) => {
  if (!projectId) return null;

  return (
    <div
      className={`whatsapp-connect-prompt${compact ? " whatsapp-connect-prompt-compact" : ""}`}
      role="status"
    >
      <div className="whatsapp-connect-prompt-icon" aria-hidden>
        <FaWhatsapp />
      </div>
      <div className="whatsapp-connect-prompt-body">
        <h2>{title}</h2>
        <p>{description}</p>
        <Link
          to={businessPath(projectId, "myprofile")}
          className="whatsapp-connect-prompt-link"
        >
          Go to My Profile
        </Link>
      </div>
    </div>
  );
};

export default WhatsAppConnectPrompt;
